export function toNumber(value?: unknown): number | undefined {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }
  if (typeof value !== 'string') {
    return undefined;
  }

  const numericValue = Number.parseFloat(value.trim());
  return Number.isFinite(numericValue) ? numericValue : undefined;
}
